export const colors = ['#FF2638', '#ED6A0C', '#FFCC00', '#1EBA1E', '#30C9CA'];
export const colors2 = ['#FF2638', '#FFCC00', '#30C9CA'].reverse();

// 分级评价：合格、一般、良好、优秀、精英
//     - 分档是合格[0-60），一般[60-70），良好[70-80），优秀[80-90），精英[90-100]
// - [60，70）明显不平衡，[70，80）轻微不平衡，[80，100]平衡
export const ELEVATION_CONFIG = {
  // 合格
  QUALIFIED: {
    i18nKey: 'H9051',
    color: '#FF2638',
    order: 0
  },
  // 一般
  NORMAL: {
    i18nKey: 'H9052',
    color: '#ED6A0C',
    order: 1
  },
  // 良好
  GOOD: {
    i18nKey: 'H9003',
    color: '#FFCC00',
    order: 2
  },
  // 优秀
  EXCELLENT: {
    i18nKey: 'H9053',
    color: '#1EBA1E',
    order: 3
  },
  // 精英
  EXPERT: {
    i18nKey: 'H9054',
    color: '#30C9CA',
    order: 4
  }
};

export const BALANCE_CONFIG = {
  // 双侧平衡
  BALANCE: {
    order: 0,
    i18nKey: 'H9064',
    color: '#30C9CA'
  },
  // 轻微不平衡
  BALANCE_LIGHT: {
    order: 1,
    i18nKey: 'H9074',
    color: '#FFCC00'
  },
  // 明显不平衡
  BALANCE_HEAVY: {
    order: 2,
    i18nKey: 'H9075',
    color: '#FF2638'
  }
};
